import { render, staticRenderFns } from "./PaymentButtons.vue?vue&type=template&id=57b443d2&scoped=true&"
import script from "./PaymentButtons.vue?vue&type=script&lang=js&"
export * from "./PaymentButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b443d2",
  null
  
)

export default component.exports